import { useLockBodyScroll } from 'react-use';

export const useLockScroll = (lock: boolean): void => {
  const isIPhone =
    typeof window !== 'undefined' &&
    window.navigator &&
    window.navigator.platform &&
    /iP(ad|hone|od)/.test(window.navigator.platform);

  useLockBodyScroll(!isIPhone && lock);

  // had to use a fallback solution for iPhone
  if (isIPhone && lock) {
    document.body.style.overflow = 'hidden';
  } else if (isIPhone && !lock) {
    document.body.style.overflow = 'auto';
  }
};
